<template>
  <div>
    <v-toolbar
      color="transparent"
      dark
      flat
      class="special-shadow"
      :style="{
        height: '400px',
        position: 'relative',
        'background-size': `${isMobile ? 'cover' : 'cover'}`,
        'background-attachment': `${isMobile ? '' : 'fixed'}`,
        'background-position': `center top`,
        'background-image': `linear-gradient(to top right,rgba(2, 21, 120, 0.9),rgba(2, 21, 120, 0.6)),url(${require('../assets/login_bg.jpg')})`,
      }"
    >
      <div>
        <v-img
          :src="require('../assets/logo-blanco.png')"
          max-height="80"
          contain
          class="mx-auto"
          :style="{
            position: 'absolute',
            left: 0,
            right: 0,
            top: `25px`,
          }"
        ></v-img>
      </div>
      <v-spacer />
      <v-menu
        :close-on-content-click="true"
        :nudge-width="200"
        offset-y
        right
        nudge-left="0"
        class="test"
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-card elevation="0">
          <v-list>
            <v-list-item>
              <v-list-item-icon class="mr-2">
                <v-avatar color="blue lighten-5" class="mr-3" size="40">
                  <v-icon color="blue darken-3" size="18">
                    mdi-account-circle
                  </v-icon>
                </v-avatar>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>
                  {{ usuario.DESCRIPCION.trim() }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ parseInt(usuario.ID) }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list>
            <v-list-item dense inactive :ripple="false">
              <v-list-item-content class="px-0 pa-0">
                <v-btn
                  depressed
                  color="red"
                  text
                  class="white--text"
                  @click="logout"
                >
                  <v-icon left>
                    mdi-exit-to-app
                  </v-icon>
                  Salir
                </v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>
  </div>
</template>
<script>
export default {
  props: {
    isMobile: Boolean,
  },
  data() {
    return {
      usuario: null,
    }
  },
  created() {
    const currentUser = this.data_auth
    this.usuario = currentUser || false
  },
  methods: {
    logout() {
      sessionStorage.removeItem('auth')
      location.reload()
    },
  },
}
</script>
